import { RepaymentTypes } from '@brickwise/asset-validation/dist/schema/enums';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from 'src/components/mui-overrides/Checkbox';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { DefaultFastTextAreaField } from 'src/components/mui-overrides/Textarea';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { TwoColumnGridContainer } from 'src/components/ui/TwoColumnGridContainer';

interface Props {
  disabled?: boolean;
}

export const LeverageInformation: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.leverageInformation.title')}>
      <TwoColumnGridContainer>
        <div>
          <CheckboxField
            label={t('dashboard.assets.addedit.main.loanInformation.fields.borrowedCapital.label')}
            fieldName="loanInformation.borrowedCapital"
            disabled={disabled}
          />
          <DefaultFastTextField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.loanInformation.fields.originalLoanAmount.label')}
            fieldName="loanInformation.originalLoanAmount"
            type="number"
          />
          <DefaultFastTextField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.loanInformation.fields.currentInterestPerY.label')}
            fieldName="loanInformation.currentInterestPerY"
            type="number"
          />
          <DefaultFastTextField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.loanInformation.fields.currentRepaymentPerY.label')}
            fieldName="loanInformation.currentRepaymentPerY"
            type="number"
          />
          <DefaultFastSelectField
            label={t('dashboard.assets.addedit.main.loanInformation.fields.repaymentType.label')}
            fieldName="loanInformation.repaymentType"
            options={[
              { value: RepaymentTypes[0], label: t('general.repaymentAmount.bulletLoan') },
              { value: RepaymentTypes[1], label: t('general.repaymentAmount.installmentLoan') },
            ]}
          />
        </div>
        <div>
          <DefaultFastTextAreaField
            disabled={disabled}
            label={t('dashboard.assets.addedit.main.loanInformation.fields.borrowedCapitalText.label')}
            fieldName="loanInformation.borrowedCapitalText"
          />
        </div>
      </TwoColumnGridContainer>
    </LaunchpadCard>
  );
};
